import React, { useContext } from "react";
import { Link } from "react-router-dom";
import TranslationsContext from "../../infrastructure/context/translations/translations-context";
import TranslationManager from "../../infrastructure/translation-manager";
import { TranslationKeys } from "../../infrastructure/const";
import { Brand } from '../../infrastructure/const';

type PageHeaderLogoProps = {
  brand?: string;
  className?: string;
  websiteId: string;
};

const PageHeaderLogo = (props: PageHeaderLogoProps): JSX.Element => {
  let logoSrc, logoAlt, logoTitle: string;
  let className: string | undefined;

  const translationsContext = useContext(TranslationsContext);
  const translationManager = new TranslationManager(translationsContext);

  switch (props.brand) {
    case Brand.Phonicear:
      logoSrc = "/images/phonic-ear-logo.png";
      logoAlt = "Phonic Ear Logo";
      logoTitle = "Phonic Ear";
      break;
    case Brand.Bernafon:
      logoSrc = "/images/bernafon-logo.png";
      logoAlt = "Bernafon Logo";
      logoTitle = "Bernafon";
      break;
    case Brand.Horselbutik:
      logoSrc = "/images/horselbutik-logo.png";
      logoAlt = "Horselbutik Logo";
      logoTitle = "Horselbutik";
      break;
    case Brand.Battery:
      logoSrc = "/images/oticon_130px.svg";
      logoAlt = "Oticon Logo";
      logoTitle = "Oticon life-changing technology";
      break;
    case Brand.Horselshop:
      logoSrc = "/images/horselshop-svg.svg";
      logoAlt = "horselshop Logo";
      logoTitle = "Horselshop";
      break;
    default:
      logoSrc = "/images/oticon_130px.svg";
      logoAlt = "Oticon Logo";
      logoTitle = "Oticon People First";
  }

  if (translationManager.getTranslation(TranslationKeys.LOGO_TITLE)) {
    logoTitle = translationManager.getTranslation(TranslationKeys.LOGO_TITLE);
  }

  className = props.className;
  
  return (
    <Link to="/" title={logoTitle} className={className || `logo ${props.brand}`}>
      <img src={logoSrc} alt={logoAlt} />
    </Link>
  );
};

export default PageHeaderLogo;
